<template>
  <!--
    The view for the CutConfig-component
  -->
  <Portlet
    :title="$t('menu.sounds')"
    icon="music"
  >
    <template slot="buttons">
      <button 
        class="btn btn-sm btn-primary float-right mt-2 mb-2" 
        @click="showSidebarAdd"
      >
        <font-awesome-icon
          class="mr-1"
          icon="plus"
        />
        <span>
          {{ $t('add') }}
        </span>
      </button>
      <div class="clearfix" />
    </template>    
    <SoundsList
      ref="soundsList"
      @reloadAuditLogs="reloadAuditLogs"
    />
    <DatabaseAuditLogList
      ref="databaseAuditLogList"
      :is-sounds="true"
      @reload="reloadSoundsList"
    />
  </Portlet>
</template>

<script>
export default {
  name: "Sounds",
  components: {
    SoundsList: () => import('@/components/VideoPostprocessing/Sounds/SoundsList.vue'),
    DatabaseAuditLogList: () => import('@/components/DatabaseAuditLogs/DatabaseAuditLogsList.vue')
  },
    methods: {
    showSidebarAdd () {
      this.$refs.soundsList.showSidebarAdd();
    },
     reloadAuditLogs () {
      this.$refs.databaseAuditLogList.reloadAuditLogs();
    },
    reloadSoundsList () {
      this.$refs.soundsList.reloadSounds();
    }
  }
}
</script>